"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeRollupValue = computeRollupValue;
/**
 * Computes a rollup value from source values using the specified aggregation
 */
function computeRollupValue(sourceValues, aggregation, separator) {
    // Filter null/undefined values
    const values = sourceValues.filter(v => v != null && v !== '');
    const totalCount = sourceValues.length;
    switch (aggregation) {
        case 'count':
            return totalCount;
        case 'count_values':
            return values.length;
        case 'count_unique':
            return new Set(values.map(String)).size;
        case 'sum':
            return values.reduce((acc, v) => {
                const num = Number(v);
                return acc + (isNaN(num) ? 0 : num);
            }, 0);
        case 'average': {
            const numericValues = values.map(v => Number(v)).filter(n => !isNaN(n));
            if (numericValues.length === 0)
                return 0;
            const sum = numericValues.reduce((acc, v) => acc + v, 0);
            return sum / numericValues.length;
        }
        case 'min': {
            const numericValues = values.map(v => Number(v)).filter(n => !isNaN(n));
            if (numericValues.length === 0)
                return null;
            return Math.min(...numericValues);
        }
        case 'max': {
            const numericValues = values.map(v => Number(v)).filter(n => !isNaN(n));
            if (numericValues.length === 0)
                return null;
            return Math.max(...numericValues);
        }
        case 'show_original':
            return values.map(String);
        case 'show_unique':
            return [...new Set(values.map(String))];
        case 'concatenate':
            return values.map(String).join(separator ?? ', ');
        case 'percent_empty':
            if (totalCount === 0)
                return 0;
            return Math.round(((totalCount - values.length) / totalCount) * 100);
        case 'percent_filled':
            if (totalCount === 0)
                return 0;
            return Math.round((values.length / totalCount) * 100);
        default:
            return null;
    }
}
